import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  BackButton,
  Container,
  Navbar,
  NavbarInfo,
  ParticipantsDropdown,
  Subheader,
  Subject,
  Title
} from './Header.styled';
import { ChevronLeft } from 'assets/icons/Icons';
import {
  getCategoryInfo,
  getFirstName,
  isClosedConversation,
  isOpenConversation,
  isResolvedConversation
} from 'screens/Messages/Messages.utils';
import { pageUrl } from 'utilities/pageUrl';
import { useBreakpoints } from 'utilities/useBreakpoints';

import { Props } from './Header.types';
import { getParticipantsMenuStructure } from './Header.utils';
import { AssigneePhoto } from '../AssigneePhoto/AssigneePhoto';
import { Badge } from '../Badge/Badge';

export const Header = ({ conversation, categoryName }: Props) => {
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoints();

  const currentCategory = getCategoryInfo(categoryName);

  const title = getFirstName(conversation?.assignedToUserName) ?? currentCategory.title;
  const subject = conversation?.subject;
  const status = conversation?.status;

  const { participantsMenuStructure, additionalParticipants } =
    getParticipantsMenuStructure(conversation);

  return (
    <Container>
      <Navbar>
        <BackButton data-testid="back-button" onClick={() => navigate(pageUrl.messages())}>
          <ChevronLeft type="solid" />
        </BackButton>
        <NavbarInfo>
          {!isDesktop && (
            <AssigneePhoto
              assignedToUserPhotoUrl={conversation?.assignedToUserPhotoUrl}
              category={currentCategory}
              categoryIconSize="sm"
            />
          )}
          <Title $multilineEllipses={1}>{title}</Title>
        </NavbarInfo>
        {participantsMenuStructure.length > 0 && (
          <ParticipantsDropdown items={participantsMenuStructure}>
            <Badge label={'+' + additionalParticipants.length} type="default" size="md" />
          </ParticipantsDropdown>
        )}
      </Navbar>

      {subject && (
        <Subheader>
          <Subject title={subject}>Subject: {subject}</Subject>

          <div>
            {isResolvedConversation(status) && <Badge label="Resolved" type="success" size="xs" />}
            {(isOpenConversation(status) || isClosedConversation(status)) && (
              <Badge label="Open" type="default" size="sm" />
            )}
          </div>
        </Subheader>
      )}
    </Container>
  );
};
